export enum LOCAL_STORAGE_KEYS {
  unsavedTripIds = "unsavedTripIds",
}
